// extracted by mini-css-extract-plugin
export default {"headingContainer":"_7uF2Ha9KLQCeruVogayejW","headingText":"_42O3nNsA4l3ZjFfkxq85Ay","venueFilter":"_2vw4gsAktjHHd8omMqsbec"};